import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';

const LeftBanner = () => {
    const [text] = useTypewriter({
      words: ["Data Analyst","Data Engineer.", "Data Scientist."],
      loop: true,
      typeSpeed: 20,
      deleteSpeed: 10,
      delaySpeed: 2000,
    });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">WELCOME TO MY WORLD</h4>
        <h1 className="text-6xl font-bold text-white">
          Hi, I'm <span className="text-designColor capitalize">Amir Amemi</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#447add"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
        I'm a Data Analyst with experience transforming complex datasets into actionable business insights across manufacturing, finance, and business intelligence domains. Currently at Infineon Technologies AG, I develop automated KPI monitoring systems using KNIME and Tableau, and build Python-based predictive models that optimize production processes and reduce operational inefficiencies.
My expertise spans the full data lifecycle—from designing ETL pipelines on AWS to creating interactive dashboards and implementing anomaly detection algorithms. I've successfully reduced manual processing time by 20+ hours per week through automation and delivered analytics solutions that drive data-driven decision-making across teams.
I'm proficient in Python, SQL, Apache Spark, KNIME, Tableau, Power BI, and AWS, with strong capabilities in statistical analysis and machine learning. I work collaboratively with process engineers and stakeholders to translate data insights into tangible business value.
This portfolio showcases projects ranging from real-time financial APIs to serverless analytics pipelines, demonstrating my ability to tackle diverse data challenges and deliver impactful results.

        </p>
      </div>
     {/* Media */}
     <Media />
    </div>
  );
}

export default LeftBanner